import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Router } from '@angular/router';

import { Authentication } from '../../shared/models/authentication.interface';
import { BaseService } from "../../shared/services/base.service";

import { Observable } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { ChangePassword } from '../../shared/models/changePassword.interface';

@Injectable()

export class LoginService extends BaseService {
  baseUrl: string;

  constructor(protected http: HttpClient, router: Router) {
    super(http, router);
  }   

  login(userName, password): Observable<Authentication> {
    let body = JSON.stringify({ userName, password });
    let options = {
      headers: new HttpHeaders({ "Content-Type": "application/json"})
    };

    return this.http
      .post(
        this.apiUrl + '/auth/login', body, options)
      .pipe(
        map((res: Authentication) => {
          this.loginUser(res);
          return res;
        }), catchError(this.handleError)
      );
  }

  sendResetEmail(email: string): Observable<any> {
    return this.httpPost<any>("/auth/sendPasswordReset/", email );
  }

  changePassword(chgPwd: ChangePassword): Observable<any> {
    return this.httpPost<any>("/auth/changePassword", chgPwd);
  }
  verifyChangeToken(chgToken: string): Observable<boolean> {
    return this.httpPost<boolean>("/auth/verifyToken/", chgToken);
  }
}
